/**
 * The street — the far skyline (a parallax layer) and the street lamps.
 *
 * @module scenes/street
 */

import { rect, scene } from './svg.js';

/**
 * Towers along 3600 units: wider than any track, drawn from repeating
 * width and height series so neighbours never match.
 *
 * @returns {import('../lib/html.js').Markup}
 */
export function skyline() {
    const widths = [150, 96, 190, 120, 74, 160, 130, 210, 100, 170, 88, 140];
    const heights = [170, 120, 240, 150, 205, 96, 255, 140, 185, 225, 110, 200];
    let towers = '';

    for (let x = 0, index = 0; x < 3600; index++) {
        const width = widths[index % widths.length];
        const height = heights[(index * 5) % heights.length];
        const top = 300 - height;

        towers += rect(x, top, width, height, 'fill-paper-3');

        // Lit windows on every other wide tower.
        if (width >= 120 && index % 2 === 0) {
            towers += rect(x + 10, top + 18, width - 26, height - 40, '', 'fill="url(#sky-windows)"');
        }

        // An antenna…
        if (index % 3 === 1) {
            towers += rect(x + Math.round(width / 2) - 2, top - 34, 4, 34, 'fill-paper-3');
        }

        // …or a water tank on its legs.
        if (index % 4 === 2) {
            towers +=
                rect(x + width - 52, top - 26, 32, 20, 'fill-paper-3') +
                rect(x + width - 48, top - 6, 4, 6, 'fill-paper-3') +
                rect(x + width - 28, top - 6, 4, 6, 'fill-paper-3');
        }

        x += width + 10;
    }

    const windows =
        '<defs><pattern id="sky-windows" width="24" height="30" patternUnits="userSpaceOnUse">' +
        rect(7, 8, 10, 14, 'fill-paper-2') +
        '</pattern></defs>';

    return scene('0 0 3600 300', windows + towers, 'xMinYMax meet');
}

/** @returns {import('../lib/html.js').Markup} */
export function lamp() {
    return scene(
        '0 0 60 420',
        rect(18, 398, 24, 22, 'fill-ink') +
            rect(27, 74, 6, 326, 'fill-ink') +
            rect(22, 36, 16, 10, 'fill-ink') +
            '<polygon points="12,66 48,66 39,44 21,44" class="fill-red"/>' +
            '<circle cx="30" cy="70" r="6" class="fill-paper"/>',
        'xMidYMax meet',
    );
}
